export default __webpack_public_path__ + "static/media/c1.7326ebba.png";